import { Component, CUSTOM_ELEMENTS_SCHEMA, Inject, inject, Input, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { CommonModule, Location } from "@angular/common";

import { MatCheckboxModule } from "@angular/material/checkbox";
import { FormsModule } from "@angular/forms";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { DialogService, MobiOfficeUiModule, MobiOfficeUIState, UnSubscriber, GlobalService as MainGlobalService } from "@mobi-office-ui";
import { Int_numberField, IntTelInputComponent } from "apps/vm-admin-ui/src/components/int-tel-input/int-tel-input.component";
import { ToastrService } from "ngx-toastr";
import { Int_update_vm, Int_vm_user } from "../../models/types";
import { MasterService } from "apps/vm-admin-ui/src/services/master.service";
import { select, Store } from "@ngrx/store";
import { TableColumnsViewComponent } from "../../shared/table-columns-view/table-columns-view.component";
import { Int_TableColumn, TABLE_COLUMN_TYPE, TABLE_NAMES } from "../../models";
import { MatIconModule } from "@angular/material/icon";
import { CustomPopupComponent } from "apps/vm-admin-ui/src/components/custom-popup/custom-popup.component";

export const ICONS = {
  BACK_ARROW: (color: string, width: number, height: number) => {
    return `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" fill="${color}" viewBox="0 0 24 24">
              <path d="M10 19l-7-7 7-7v14zm2-14h12v14h-12v-14z"/>
            </svg>`;
  },
};
export enum PAGE_TITLE {
  TEAM_MEMBERS = "Team Members",
}

export interface Int_User {
  Name: string;
  Phone: string;
  UID: number;
  IsActive?: boolean;
  PhonePreFix: string;
  numberField: Int_numberField;
  Role: any[];
}

@Component({
  selector: "mobi-office-team",
  imports: [MatIconModule, MatCheckboxModule, FormsModule, MobiOfficeUiModule, IntTelInputComponent, TableColumnsViewComponent, CommonModule],
  templateUrl: "./team.component.html",
  styleUrl: "./team.component.scss",
})
export class TeamComponent extends UnSubscriber implements OnInit {
  readonly dialogService = inject(DialogService);
  readonly dialog = inject(MatDialog);
  readonly location = inject(Location);
  readonly ICONS = ICONS;
  readonly toastr = inject(ToastrService);
  readonly masterService = inject(MasterService);
  readonly mainGlobalService = inject(MainGlobalService);
  readonly store = inject(Store<MobiOfficeUIState>);

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.fetchRoles();

    this.handleTeamPage();
    this.getTeamList();
  }

  @ViewChild("AddTeamMemberTemplate") AddTeamMemberTemplate!: TemplateRef<any>;

  tableColumns: Int_TableColumn[] = [];
  pageTitle = PAGE_TITLE.TEAM_MEMBERS;
  teamMembers: any[] = [];
  dataSource: any[] = [];
  roleList: any[] = [];
  filteredRoles: any[] = [];
  userInfo: any = {};

  team: Int_User = {
    Name: "",
    Phone: "",
    UID: 0,
    PhonePreFix: "",
    numberField: {
      dialCode: "",
      number: "",
    },
    Role: [],
  };

  teamEdit: boolean = false;

  onBack() {
    this.location.back();
  }

  openDialog(template: TemplateRef<any>, onClose: () => void): void {
    const dialogConfig = new MatDialogConfig();
    this.dialogService.matDialogDefaultConfig(dialogConfig);
    dialogConfig.width = "500px";
    dialogConfig.data = { isMultiple: true };
    const dialogRef = this.dialog.open(template, dialogConfig);
    this.anotherSubscription = dialogRef.afterClosed().subscribe(() => {
      onClose();
    });
  }

  onOpenPopup() {
    this.team = {
      Name: "",
      Phone: "",
      UID: 0,
      PhonePreFix: "",
      Role: [],
      numberField: {
        dialCode: "",
        number: "",
      },
    };

    this.openDialog(this.AddTeamMemberTemplate, () => {});
  }

  onClose() {
    this.dialog.closeAll();
  }

  onEditTeamMember() {
    const dialCode = this.team.numberField?.dialCode.replace("+", "");
    const payload: Int_update_vm = {
      Name: this.team.Name,
      PhoneNumber: dialCode + this.team.numberField?.number,
      PhonePreFix: this.team.numberField?.dialCode || "",
      UID: this.team.UID,
      IsActive: this.team.IsActive,
      Roles: this.team.Role,
    };

    if (!this.team.Name) {
      this.toastr.info("Name is required", "info");
      return;
    }

    if (!this.team.Phone) {
      this.toastr.info("Phone is Required", "info");
      return;
    }

    this.anotherSubscription = this.masterService.UpdateVMUser(payload).subscribe(() => {
      this.getTeamList();
      this.dialog.closeAll();
    });
  }

  fetchRoles() {
    this.anotherSubscription = this.masterService.getRoles().subscribe((response: any) => {
      console.log("table responce", response.Table);
      this.roleList = response.Table;
    });
  }

  onAddTeamMember() {
    if (!this.team.Name.trim()) {
      this.toastr.info("Name is required", "Info");
    }

    this.team.Phone = this.team.numberField.number;

    if (!/^\d+$/.test(this.team.Phone)) {
      this.toastr.error("Phone number must contain only numbers", "Error");
      return;
    }

    if (this.team.Role.length === 0) {
      this.toastr.info("Role not be empty", "Info");
    }
    const code = this.team.numberField.dialCode.replace("+", "");

    const payload: Int_vm_user = {
      Name: this.team.Name,
      PhoneNumber: code + this.team.Phone,
      PhonePreFix: code,
      Roles: this.team.Role,
    };

    this.anotherSubscription = this.masterService.InsertVmUser(payload).subscribe((res: any) => {
      this.getTeamList();
      this.dialog.closeAll();
    });
  }

  private handleTeamPage() {
    this.anotherSubscription = this.mainGlobalService.onDefaultColumn$(TABLE_NAMES.TEAM_MEMBERS_LIST).subscribe((res: any) => {
      const totalColumns = res.DefaultColumns;
      const ActionColumn: Int_TableColumn = {
        title: "Action",
        sortByKey: "",
        onDelete: (row: any) => this.handleTeamDelete(row),
        onEdit: (row: any) => this.handleTeamEdit(row),
        type: TABLE_COLUMN_TYPE.ACTION,
        dataIndex: 0,
        viewKey: "",
        headerAlign: "end",
        bodyAlign: "end",
      };

      this.tableColumns = res.TableColumns.map((el: any, index: number) => ({
        title: el.headingName,
        sortByKey: el.valueKey,
        viewKey: el.valueKey,
        type: TABLE_COLUMN_TYPE.TEXT,
        isSortable: true,
        isSelected: true,
        dataIndex: index,
        headerAlign: "start",
        bodyAlign: "start",
        customHeaderClass: "",
        customBodyClass: "",
      }));

      if (totalColumns.includes("Action")) {
        this.tableColumns.push(ActionColumn);
      }
    });
  }

  private handleTeamDelete(row: Int_User) {
    if (!row.IsActive) {
      this.toastr.info("Unable to delete an inactive user.", "Info");
      return;
    }
    this.team.UID = row.UID;

    this.dialog.open(CustomPopupComponent, {
      width: "500px",
      data: {
        confirmMsg: "Are you sure you want to delete?",
        onNo: () => {
          this.dialog.closeAll();
        },
        onYes: () => {
          this.onDeleteTeam();
        },
      },
    });
  }

  onDeleteTeam() {
    this.anotherSubscription = this.masterService.UpdateUserInactive({ UID: this.team.UID }).subscribe((res: any) => {
      this.getTeamList();
      this.dialog.closeAll();
    });
  }

  private handleTeamEdit(row: any) {
    const code = row.PhonePreFix.replace("+", "");
    const tempNumber = row.Phone.startsWith(code) ? row.Phone.substring(code.length) : row.Phone;

    this.team = {
      ...this.team,
      Name: row?.Name || "",
      Phone: row?.Phone || "",
      UID: row?.UID || 0,
      IsActive: row?.IsActive || false,
      numberField: {
        dialCode: row.PhonePreFix,
        number: tempNumber,
      },

      Role: row?.U_LURList.map((el: any) => el.RID) || [],
    };
    console.log("team", this.team);
    this.teamEdit = true;

    this.openDialog(this.AddTeamMemberTemplate, () => {
      this.teamEdit = false;
    });
  }

  private getTeamList() {
    this.anotherSubscription = this.masterService.getTeamList().subscribe((res: any) => {
      res.Table = res.Table.map((el: any) => {
        return {
          ...el,
          Role: el.U_LURList.map((role: any) => role.Name),
        };
      });
      this.dataSource = res.Table;
    });
  }
}
